document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(),
		win = $(window).width(),
		d = new Date(),
		n = d.getFullYear(),
		page = $('html, body'),
		pageUrl = window.location.href,
		i = 0;

	$('.foo__copy em').text(n).addClass('foo__copy-year');

	// WP Remove <p> tags
	$('div.row p:empty').hide();

	/**
	 * Mobile Menu Toggle
	 */
	$(document).on('click','.navbar-toggler-btn', function() {
		$('body').toggleClass("menu-open");
	});

	$('.header-nav-overlay').on('click', function() {
		$('.navbar-toggler-btn').trigger('click');
	});

	$(window).resize(function () {
		$('.tfa-header-menu-container .navbar-nav input').prop('checked', false);
	});

	$('.navbar-nav .nav-shop, .navbar-nav .nav-resources, .navbar-nav .nav-about').addClass('fancybox-inline');

	$('.tfa-header-menu-container .navbar-nav>.menu-item a').each(function() {
		var target = $(this).attr('href');
		if( pageUrl === target ) {
			$(this).parent('.nav-item').addClass('menu-item-current');
		} else {
			$(this).parent('.nav-item').removeClass('menu-item-current');
		}
	});

	$('.wpcf7-select, .acf-form select, .filter-posts select, .wc-block-catalog-sorting .orderby, .wc-block-components-sort-select__select, .wc-block-product-categories__dropdown select').select2( { minimumResultsForSearch: 20 } );

	$('body').on('wpcf7-field-groups/added', function(e, g) {
		let $select = $(g).find('.wpcf7-select');
		$select.each(function(i, select) {
			$(select).removeClass('select2-hidden-accessible')
				.removeAttr('data-select2-id')
				.siblings('.select2-container').remove();
			$(select).select2({ minimumResultsForSearch: 20 });
		});
	});

	var postTitle = $("meta[property='og:title']").attr("content");
	var postContent = postTitle + ' - ' + pageUrl;

	$('.bssbSocialShare li.icon[data-social="mail"]').click(function() {
		window.location = "mailto:?subject=" + postTitle + "&body=" + postContent;
	});

	// Remove empty p & style tags
	$('div').each(function() { 
		if ( $(this).attr('style') === '' )  { 
			$(this).removeAttr('style')
		}
	});

	$(".img-cover img").each(function(i, elem) {
		var h = $(this).parents('.img-cover').siblings().height() + 200;
		var img = $(elem);
		img.css("height",h);
	});

	/**
	 * Form Range field
	 */
	var rangeSlider = function() {

		var slider = $('.range-slider'),
			range = $('.range-slider__range'),
			value = $('.range-slider__value');
		
		slider.each(function() {
	
			value.each(function(){
				var value = $(this).prev().attr('value');
				$(this).html(value).val(value);
			});
		
			range.on('input', function(){
				$(this).next(value).html(this.value);
				$(this).attr('value',this.value);
			});
		});
	};
	rangeSlider();

	$("#menu-main-header-menu .nav-link.dropdown-toggle")
		.removeAttr('href')
		.each(function() {
			const $toggle = $(this);

			if ($toggle.attr('data-bs-toggle')) {
				$toggle.attr('data-menu-dropdown-toggle', $toggle.attr('data-bs-toggle'));
			}
		});

	function handleResize() {
		const $dropdownToggles = $('.nav-link.dropdown-toggle');

		if (window.matchMedia("(max-width: 1399px)").matches === true) {
			$dropdownToggles
				.removeAttr('data-bs-toggle')
				.attr('aria-expanded', 'false')
				.off('click.menuDropdown');
			$(document).off('click.menuDropdown');
			
			$dropdownToggles.on('click.menuDropdown', function(e) {
					e.preventDefault();
					e.stopPropagation();
					
					const $toggle = $(this);
					const $dropdown = $toggle.parent('.dropdown');
					const $dropdownMenu = $(this).siblings('.dropdown-menu');
					const isVisible = $dropdownMenu.is(':visible');

					$('.navbar-nav .dropdown').not($dropdown).removeClass('show');
					$('.navbar-nav .dropdown > .nav-link.dropdown-toggle').not($toggle).removeClass('show');
					$('.navbar-nav .dropdown > .dropdown-menu').not($dropdownMenu).removeClass('show').attr('style', 'display: none !important');

					$dropdownMenu.toggle(!isVisible);
					$dropdown.toggleClass('show', !isVisible);
					$toggle.toggleClass('show', !isVisible);
					$dropdownMenu.toggleClass('show', !isVisible);
					$dropdownMenu.attr('style', !isVisible ? 'display: block !important;opacity: 1;visibility: visible;' : 'display: none !important');
			});

			$(document).on('click.menuDropdown', function(e) {
				if ($(e.target).closest('.nav-link.dropdown-toggle, .dropdown-menu').length) {
					return;
				}

				$('.navbar-nav .dropdown').removeClass('show');
				$('.navbar-nav .dropdown > .nav-link.dropdown-toggle').removeClass('show');
				$('.navbar-nav .dropdown > .dropdown-menu').removeClass('show').attr('style', 'display: none !important');
			});
		  
			// $(document).on('click', function(e) {
			// 	if (!$(e.target).closest('.dropdown').length) {
			// 	$('.navbar-nav .dropdown > .dropdown-menu').attr('style', 'display: block !important;');
			// 	}
			// });
		// } else if (window.matchMedia("(min-width: 1024px)").matches === true) {	
		// 	// Sidebar Sticky
		// 	var $sidebar = $('.sp__sidebar.singlepost_sidebar');
		
		// 	if ($sidebar.find('.sticky-container').length === 0) {
		// 		$sidebar.wrapInner('<div class="sticky-container"></div>');
		// 	}
			
		// 	var $sidebar = new hcSticky('.sp__sidebar.singlepost_sidebar .sticky-container', { 
		// 		top: 160, 
		// 		bottomEnd: 0, 
		// 		innerTop: 0, 
		// 		stickyClass: 'is-sticky', 
		// 		responsive: { 
		// 			1024: { 
		// 			disable: true 
		// 			} 
		// 	} 
		// 	});
		} else {
			$dropdownToggles
				.removeAttr('data-bs-toggle')
				.attr('aria-expanded', 'false')
				.off('click.menuDropdown')
				.removeClass('show');
			$(document).off('click.menuDropdown');
			$('.navbar-nav .dropdown').removeClass('show');
			$('.navbar-nav .dropdown > .dropdown-menu').removeClass('show').removeAttr('style');
		}
	}
	  
	  
	handleResize();
	$('.navbar-collapse').removeClass('show');

	  
	$(window).on('resize', function() {
		handleResize();
	});

	$('.tab-pane ul li').on('click', function() {
		$(this).find('a')[0].click();
	});

	$('#term-dropdown').select2({
        minimumResultsForSearch: Infinity,
        width: '150px'
    });
    
	$('.sortby .dropdown-class').each(function() {
		var $select = $(this);
		var $parent = $select.closest('.sortby');

		if ($select.hasClass('select2-hidden-accessible')) {
			$select.select2('destroy');
		}

		$select.select2({
			minimumResultsForSearch: Infinity,
			width: 'resolve',
			dropdownParent: $parent.length ? $parent : $(document.body)
		});
	});

	$('.podcast-latest.post-list .items .item').addClass('row');
	$('.podcast-latest.post-list .items .item .thumb').addClass('col');
	$('.podcast-latest.post-list .items .item .det').addClass('col');

	$('#popmake-670').after('<div class="link-bottom"><a href="#">Need help with your EML account?</a></div>');


	/**
	 * making podcasts cards linkeable
	 */
	$('article.podcasts, article.testimonials').on('click', function(){
        window.location = $(this).find("a").attr("href");
    });



	/**
	 * check and change bg hr sidebar servides
	 */
	setTimeout(function() {
		if ($('.hero-options.hero-options--health').length > 0) {
			$('.sp__sidebar.singlepost_sidebar.sidebar-services #wsf-1-sections-7 #wsf-1-section-8 legend').css('background-color', '#50C878');
		}
	}, 100);


	/**
	 * Home grid hover feature
	 */
    var $allImages = $('.sixgrid .wp-block-image');
    var $webinarElement = $('.wp-block-image.webinar');
    var $podcastsElement = $('.wp-block-image.podcasts');
    
    $('.sixgrid .col').hover(
        function() {
            $(this).find('.wp-block-image').addClass('hover-active');
        },
        function() {
            $(this).find('.wp-block-image').removeClass('hover-active');
        }
    );
    
    $webinarElement.hover(
        function(e) {
            e.stopPropagation();
            
            $allImages.removeClass('hover-active');
            $webinarElement.addClass('hover-active');
            $podcastsElement.addClass('no-hover-effect');
        },
        function(e) {
            e.stopPropagation();
            
            $webinarElement.removeClass('hover-active');
            $podcastsElement.removeClass('no-hover-effect');
        }
    );
    
    $podcastsElement.hover(
        function(e) {
            e.stopPropagation();
            
            $allImages.removeClass('hover-active');
            $podcastsElement.addClass('hover-active');
            $webinarElement.addClass('no-hover-effect');
        },
        function(e) {
            e.stopPropagation();
            
            $podcastsElement.removeClass('hover-active');
            $webinarElement.removeClass('no-hover-effect');
        }
    );


	/**
	 * ScrollUp button
	 */
	var scrollTopButton = $('<button id="scrollTopBtn"></button>');
	$('body').append(scrollTopButton);
	
	scrollTopButton.hide();
	
	$(window).scroll(function() {
	  
	  var footerPosition = $('footer').length ? $('footer').offset().top : $(document).height();
	  
	  var currentPosition = $(window).scrollTop() + $(window).height();
	  
	  if(currentPosition > (footerPosition - 200)) {
		scrollTopButton.fadeIn();
	  } else {
		scrollTopButton.fadeOut();
	  }
	});

	scrollTopButton.click(function() {

	  $('html, body').animate({
		scrollTop: 0
	  }, 800);
	  
	  return false;
	});


	/**
	 * Book HR audit submit event text
	 */
    function checkForAlert() {
        const $alert = $('[role="alert"]:visible');
        const $header = $('.header-audit');
        
        if ($alert.length > 0 && $header.length > 0) {
            
            const alertText = $alert.text().toLowerCase();
            
            if (alertText.includes('email sent') || 
                alertText.includes('success') || 
                $alert.find('.alert-success').length > 0) {
                
                $header
                    .text('Thank you! Your HR Audit is confirmed.')
                    .css('color', '#414042')
                    .hide()
                    .fadeIn(500);
                
                console.log('Header changed successfully');
                return true;
            }
        }
        return false;
    }
    
    let attempts = 0;
    const maxAttempts = 30;
    
    const checkInterval = setInterval(function() {
        attempts++;
        
        if (checkForAlert() || attempts >= maxAttempts) {
            clearInterval(checkInterval);
        }
    }, 1000);
    
    checkForAlert();

	/**
	 * buttons added on mobile menu
	 */
	// $('.navbar-toggler').click(function() {
	// 	if (window.matchMedia('(max-width: 1199px)').matches) {
	// 		if ($('.navbar-nav .wp-block-button a[href="/book-a-no-obligation-call/"]').length === 0) { 
	// 			$('.navbar-nav').append('<div class="wp-block-button is-style-fill"><a href="/book-a-no-obligation-call/" class="wp-block-button__link wp-element-button">Book a no obligation call</a></div>');
	// 		}
	// 		if ($('.navbar-nav .wp-block-button a[href="/book-a-hr-audit/"]').length === 0) {
	// 			$('.navbar-nav').append('<div class="wp-block-button is-style-fill book"><a href="/book-a-hr-audit/" href="/book-a-hr-audit/" class="wp-block-button__link wp-element-button">Book a HR Audit</a></div>');
	// 		}
	// 		if ($('.navbar-nav a[href="/login/"]').length === 0) {
	// 			$('.navbar-nav').append('<a style="font-weight:500;text-decoration:underline;"; href="/login/" class="nav-link px-2">User Account');
	// 		}
			
	// 	}
	// });
	// $('.btn-close').click(function() {
	// 	$('.navbar-nav .wp-block-button').remove();
	// });


	/**
	 * Training menu hover
	 */

	$('.trainingmenu-content').hide();

	$('.trainingmenu').hover(function() {
		$('.trainingmenu-content').css('display', 'flex');
	});
	
	$('.trainingmenu-content').mouseleave(function() {
		$('.trainingmenu-content').hide();
	});

	$('.search-collapse.desktop-search').css('display','none');


	$('.search-toggler-icon, .navbar-toggler-icon').click(function() {
		const isSearchToggler = $(this).hasClass('search-toggler-icon');
		const $search = $('.search-collapse.desktop-search');
		const $navbar = $('.navbar-collapse.collapse');
		
		// Prevent multiple rapid clicks
		if ($(this).hasClass('disabled')) return;
		$(this).addClass('disabled');
		setTimeout(() => $(this).removeClass('disabled'), 500);
		
		if (isSearchToggler) {
			// Current search status
			const willShowSearch = !$search.is(':visible');
			
			// Close menu if we are going to open search
			if (willShowSearch && $navbar.hasClass('show')) {
				$navbar.collapse('hide');
			}
			
			$search.stop(true, true).fadeToggle(400);
			
		} else {
			// Current menu status
			const willShowNavbar = !$navbar.hasClass('show');
			
			// Close search if we are going to open menu
			if (willShowNavbar && $search.is(':visible')) {
				$search.stop(true, true).fadeOut(400);
			}
			
			// Use the Bootstrap method to toggle the menu
			$navbar.collapse('toggle');
		}
	});

	// $('a.nav-link.dropdown-toggle.active').removeClass('active');

	$(function () {

		const $fab     = $('#contact-fab');
		const $drawer  = $('#contact-drawer');
		const $overlay = $('#contact-overlay');

		function openDrawer() {
			if (!$drawer.hasClass('is-open')) {
				$drawer.addClass('is-open');
				$overlay.addClass('is-open');
				$fab.attr('aria-expanded', 'true');
			}
		}

		function toggleDrawer() {
			const isOpen = $drawer.hasClass('is-open');

			$drawer.toggleClass('is-open');
			$overlay.toggleClass('is-open');
			$fab.attr('aria-expanded', !isOpen);
		}

		function closeDrawer() {
			$drawer.removeClass('is-open');
			$overlay.removeClass('is-open');
			$fab.attr('aria-expanded', 'false');
		}

		// FAB button — toggle
		$fab.on('click', toggleDrawer);

		// Any .contact-trigger anywhere on the page — always opens
		$(document).on('click', '.contact-trigger', openDrawer);

		// Close on overlay click
		$overlay.on('click', closeDrawer);

		// Close drawer via the close button
		$(document).on('click', '#contact-drawer-close', closeDrawer);

		// Close drawer when the Escape key is pressed
		$(document).on('keydown', function (e) {
			if (e.key === 'Escape') closeDrawer();
		});

	});

});